module.exports = __webpack_public_path__ + "media/images/lb/853-2484454cf2dca7abdaba2c7c6f391fe1.svg";